// IE 2026 10 08 / ODOO-5800 (замер ботом на dev02: клик по «Я» / «Всі» в панели настроек слал set_/clear_default_variant ДВАЖДЫ):
// ячейка-флаг грида — `<label><input type=checkbox class="wj-cell-check"></label>` (wijmo); клик по label (поле ячейки вокруг квадратика) по
// правилам HTML порождает ВТОРОЙ click уже на input — новое событие, метка e.__agClickDone грида его не знает → execute_click → cellClick_method второй раз.
// Лечение у обработчика колонки: клик, пришедший по label (не по самому input), гасит активацию label (preventDefault) — второго click не будет.
// Клик прямо по input — активации label нет, событие одно, ничего не гасим. Чистая функция без DOM — tests/unit/settingsListClick.test.mjs.
export function labelClick_cancelActivation(e) {
    const t = e?.target
    if (!t || typeof t.closest !== 'function') return false
    if (String(t.tagName || '').toUpperCase() === 'INPUT') return false
    const label = t.closest('label')
    if (!label || !label.querySelector?.('input[type=checkbox]')) return false
    try { e.preventDefault?.() } catch (err) { /* frozen event */ }
    return true
}
